export default __webpack_public_path__ + "static/TSD_Meltwater_Graphs-1-29f438b9fd4aaf3c53b5051e375ad667.png";